export class IncreaseHttpCallCount {
  static readonly type = '[UI] Increasing HTTP Call Count';
}​
